import React, { useEffect, useState } from "react";
import { getListings } from "../../../../api/listings";
import { ListingsFromApi } from "../../../../interfaces/training-plan/ListingsFromApi";
import {
  ExploreNoResultsHeader,
  NoResults,
} from "../exploreNoResults/ExploreNoResultsHeader";
import { Stack } from "@mui/material";
import { MaterialCard } from "../cards/MaterialCard";
import { MaterialCardLoading } from "../cards/MaterialCardLoading";
import { MOCK_ARRAY_10 } from "../../../../lib/constants";

export const ExploreTrainingPlanNoResults = () => {
  const [listings, setListings] = useState<ListingsFromApi>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getListings("", 0)
      .then((resListings) => {
        setListings(resListings);
        setIsLoading(false);
      })
      .catch((e: Error) => {
        console.error(e);
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <ExploreNoResultsHeader noResults={NoResults.TRAININGPLANS} />
      <Stack
        className="w-full grid grid-col-1  sm:grid-cols-2 
            md:grid-cols-3 2xl:grid-cols-5
                    gap-3  md:gap-x-4 gap-y-6 lg:gap-6"
      >
        {!isLoading
          ? listings?.rows.map((item, i) => {
              return <MaterialCard data={item} key={i} />;
            })
          : MOCK_ARRAY_10.map((item) => {
              return <MaterialCardLoading key={item} />;
            })}
      </Stack>
    </>
  );
};
